import { render, staticRenderFns } from "./SliderControllers.vue?vue&type=template&id=0cb9057b&scoped=true"
import script from "./SliderControllers.vue?vue&type=script&lang=js"
export * from "./SliderControllers.vue?vue&type=script&lang=js"
import style0 from "./SliderControllers.vue?vue&type=style&index=0&id=0cb9057b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb9057b",
  null
  
)

export default component.exports